// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__SzAfz","pai":"Breadcrumb_pai__McLEe","separador":"Breadcrumb_separador__bh6R7","atual":"Breadcrumb_atual__EG0bD"};